module.exports = __webpack_public_path__ + "img/change.024301bb.svg";